"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var Observable_1 = require("rxjs/Observable");
var operators_1 = require("rxjs/operators");
var response_data_model_1 = require("../../model/response-data.model");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var serialization_helper_1 = require("./serialization-helper");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var main_entity_model_1 = require("../../model/main-entity.model");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var entity_service_1 = require("../api/entity.service");
var lookup_fields_1 = require("./model/lookup-fields");
var lookup_fields_values_1 = require("./model/lookup-fields-values");
var sub_entity_model_1 = require("../../model/sub-entity.model");
var entity_meta_fields_1 = require("./model/entity-meta-fields");
// tslint:disable:max-line-length
// tslint:disable:no-any
// tslint:disable:no-null-keyword
var EntitySearchHelperNewService = /** @class */ (function () {
    function EntitySearchHelperNewService(_kbService, _languageService, _classifierService, _entitySearchService) {
        this._kbService = _kbService;
        this._languageService = _languageService;
        this._classifierService = _classifierService;
        this._entitySearchService = _entitySearchService;
    }
    EntitySearchHelperNewService.prototype.deserializeEntities = function (systemName, entities$, fieldsToLoad, categoryPermissionTypes, kbPrefix) {
        var _this = this;
        if (kbPrefix === void 0) { kbPrefix = 'de'; }
        return this._languageService.getAvailableLanguages().pipe(operators_1.take(1), operators_1.switchMap(function (languages) {
            return entities$.pipe(operators_1.switchMap(function (entities) {
                if (entities.data.length > 0) {
                    return _this.collectMetaFields(systemName, fieldsToLoad, kbPrefix).pipe(operators_1.switchMap(function (entityMetaFields) {
                        var lookupFields = _this.collectCompoundFields(entities.data, entityMetaFields);
                        return _this.loadCompoundFields(systemName, entityMetaFields, lookupFields, categoryPermissionTypes);
                    }), operators_1.map(function (lookupFieldsValues) { return entities.data.map(function (entityRow) {
                        return _this.deserializeEntity(systemName, entityRow, lookupFieldsValues, languages, categoryPermissionTypes);
                    }); }), operators_1.map(function (serializedEntities) {
                        var serviceResponse = new response_data_model_1.ResponseData();
                        serviceResponse.setTotalRowCount(entities.meta.totalRowCount);
                        serviceResponse.setData(serializedEntities);
                        return serviceResponse;
                    }));
                }
                var emptyServiceResponse = new response_data_model_1.ResponseData();
                emptyServiceResponse.setTotalRowCount(0);
                emptyServiceResponse.setData([]);
                return Observable_1.Observable.of(emptyServiceResponse);
            }));
        }));
    };
    /**
     * Deserialize main entity
     * @param category  Entity's category name
     * @param entityRow Entity's not serialized data loaded from entity search service
     * @param lookupFieldsValues  All lookup fields values
     * @param languages All available languages list
     * @param categoryPermissionTypes
     * @private
     */
    EntitySearchHelperNewService.prototype.deserializeEntity = function (category, entityRow, lookupFieldsValues, languages, categoryPermissionTypes) {
        var entityMetaFields = lookupFieldsValues.lookupFields.entityMetaFields;
        var fields = entityMetaFields.fields;
        var subFields = entityMetaFields.subFields;
        var entity = new idm_de_core_frontend_1.EntityBuilder().createEntity(main_entity_model_1.MainEntity, fields);
        var simpleFields = fields.filter(function (field) { return !serialization_helper_1.isCompoundField(field); });
        var compoundFields = fields.filter(function (field) { return serialization_helper_1.isCompoundField(field) && serialization_helper_1.isFieldValueNotEmpty(field, entityRow); });
        // deserialize simple fields
        idm_de_core_frontend_1.deserializeSimpleFields(simpleFields, languages, entity, entityRow);
        // deserialize compound fields
        return this.deserializeCompoundFields(compoundFields, entity, entityRow, subFields, lookupFieldsValues, languages, categoryPermissionTypes);
    };
    /**
     * Deserialize entity compound fields
     * @param fields  Metafields of specified entity
     * @param entity  Semi serialized entity
     * @param entityRow Entity not serialized data loaded from entity search service
     * @param subFields Nested sub entities fields
     * @param lookupFieldsValues Preloaded all lookup fields values
     * @param languages All available languages list
     * @param categoryPermissionTypes
     * @private
     */
    EntitySearchHelperNewService.prototype.deserializeCompoundFields = function (fields, entity, entityRow, subFields, lookupFieldsValues, languages, categoryPermissionTypes) {
        if (fields.length > 0) {
            var _loop_1 = function (field) {
                switch (field.getType()) {
                    case idm_kb_service_client_js_1.MetaFieldType.CLASSIFIER:
                    case idm_kb_service_client_js_1.MetaFieldType.WORKFLOW_STATE:
                        var classifier = lookupFieldsValues.lookupClassifiersValues.get(field.getCompoundCategorySystemName());
                        if (classifier && classifier.get(entityRow[field.getSystemName()])) {
                            entity.getProperty(field.getSystemName()).value = classifier.get(entityRow[field.getSystemName()]);
                        }
                        else {
                            entity.getProperty(field.getSystemName()).value = null;
                        }
                        break;
                    case idm_kb_service_client_js_1.MetaFieldType.MULTI_SELECT:
                        entity.getProperty(field.getSystemName()).value = entityRow[field.getSystemName()]
                            .map(function (id) {
                            if (lookupFieldsValues.lookupClassifiersValues.get(field.getCompoundCategorySystemName())) {
                                return lookupFieldsValues.lookupClassifiersValues.get(field.getCompoundCategorySystemName()).get(id);
                            }
                            else {
                                return null;
                            }
                        })
                            .filter(function (value) { return !!value; });
                        break;
                    case idm_kb_service_client_js_1.MetaFieldType.MAIN_ENTITY:
                        var mainEntity = lookupFieldsValues.lookupEntitiesValues.get(field.getCompoundCategorySystemName());
                        if (mainEntity && mainEntity.get(entityRow[field.getSystemName()])) {
                            entity.getProperty(field.getSystemName()).value = mainEntity.get(entityRow[field.getSystemName()]);
                        }
                        else {
                            entity.getProperty(field.getSystemName()).value = null;
                        }
                        break;
                    case idm_kb_service_client_js_1.MetaFieldType.SUB_ENTITY:
                        var subEntityMetaFields = subFields.get(field.getCompoundCategorySystemName());
                        var _loop_2 = function (subEntityRow) {
                            var subEntity = new idm_de_core_frontend_1.EntityBuilder().createEntity(sub_entity_model_1.SubEntity, subEntityMetaFields.fields);
                            var simpleFields = subEntityMetaFields.fields.filter(function (subField) { return !serialization_helper_1.isCompoundField(subField); });
                            var compoundFields = subEntityMetaFields.fields.filter(function (subField) { return serialization_helper_1.isCompoundField(subField) && serialization_helper_1.isFieldValueNotEmpty(subField, subEntityRow); });
                            // deserialize sub entity's simple fields
                            idm_de_core_frontend_1.deserializeSimpleFields(simpleFields, languages, subEntity, subEntityRow);
                            // deserialize sub entity's compound fields
                            var deSerializedSubEntity = this_1.deserializeCompoundFields(compoundFields, subEntity, subEntityRow, subEntityMetaFields.subFields, lookupFieldsValues, languages, categoryPermissionTypes);
                            entity.getProperty(field.getSystemName()).value.push(deSerializedSubEntity);
                        };
                        for (var _i = 0, _a = entityRow[field.getSystemName()]; _i < _a.length; _i++) {
                            var subEntityRow = _a[_i];
                            _loop_2(subEntityRow);
                        }
                        break;
                    case idm_kb_service_client_js_1.MetaFieldType.ACCOUNTING:
                        entity.getProperty(field.getSystemName()).value = entityRow[field.getSystemName()];
                        break;
                }
            };
            var this_1 = this;
            for (var _i = 0, fields_1 = fields; _i < fields_1.length; _i++) {
                var field = fields_1[_i];
                _loop_1(field);
            }
        }
        return entity;
    };
    /**
     * Collect all meta fields of specified category and all sub entities fields
     * @param category  Meta category system name.
     * @param fieldsToLoad  Optional parameters to specify which fields must be considered.
     * @param kbPrefix
     * @return  Entity's meta fields and child sub entities fields
     * @private
     */
    EntitySearchHelperNewService.prototype.collectMetaFields = function (category, fieldsToLoad, kbPrefix) {
        var _this = this;
        if (kbPrefix === void 0) { kbPrefix = 'de'; }
        return this._kbService.getMetaFields(category, kbPrefix).pipe(operators_1.map(function (fields) {
            if (fieldsToLoad && fieldsToLoad.get(category)) {
                return fields.filter(function (metaField) { return fieldsToLoad.get(category).some(function (fieldToLoad) { return metaField.getSystemName() === fieldToLoad; }); });
            }
            return fields;
        }), operators_1.switchMap(function (fields) {
            // collect sub entities meta fields
            var subEntitiesMetaFields$ = fields.filter(function (field) { return field.getType() === idm_kb_service_client_js_1.MetaFieldType.SUB_ENTITY; })
                .map(function (field) { return _this.collectMetaFields(field.getCompoundCategorySystemName(), fieldsToLoad, kbPrefix)
                .pipe(operators_1.map(function (subEntityMetaFields) { return new Map().set(field.getCompoundCategorySystemName(), subEntityMetaFields); })); });
            if (subEntitiesMetaFields$.length > 0) {
                return Observable_1.Observable.zip.apply(Observable_1.Observable, subEntitiesMetaFields$).pipe(operators_1.map(function (subEntitiesMetaFields) {
                    var subFields = new Map();
                    for (var _i = 0, subEntitiesMetaFields_1 = subEntitiesMetaFields; _i < subEntitiesMetaFields_1.length; _i++) {
                        var subEntityMetaFields = subEntitiesMetaFields_1[_i];
                        for (var _a = 0, _b = Array.from(subEntityMetaFields.keys()); _a < _b.length; _a++) {
                            var subEntityCategory = _b[_a];
                            subFields.set(subEntityCategory, subEntityMetaFields.get(subEntityCategory));
                        }
                    }
                    return new entity_meta_fields_1.EntityMetaFields(fields, subFields);
                }));
            }
            return Observable_1.Observable.of(new entity_meta_fields_1.EntityMetaFields(fields, new Map()));
        }));
    };
    /**
     * Collect all classifier and main entity lookup fields ids and information about lookup entities deserialization.
     * @param entities  Main or sub entities from entity search result
     * @param entityMetaFields  Main or sub entity KB meta fields and child sub entities fields
     * @return  All lookup fields ids.
     * @private
     */
    EntitySearchHelperNewService.prototype.collectCompoundFields = function (entities, entityMetaFields) {
        var entityFields = entityMetaFields.fields;
        var lookupClassifiers = new Map();
        var lookupEntities = new Map();
        for (var _i = 0, entities_1 = entities; _i < entities_1.length; _i++) {
            var entity = entities_1[_i];
            for (var _a = 0, entityFields_1 = entityFields; _a < entityFields_1.length; _a++) {
                var field = entityFields_1[_a];
                if (serialization_helper_1.isCompoundField(field) && serialization_helper_1.isFieldValueNotEmpty(field, entity)) {
                    var fieldType = field.getType();
                    switch (fieldType) {
                        case idm_kb_service_client_js_1.MetaFieldType.CLASSIFIER:
                        case idm_kb_service_client_js_1.MetaFieldType.WORKFLOW_STATE: {
                            // prepare classifier collected set
                            if (!lookupClassifiers.has(field.getCompoundCategorySystemName())) {
                                lookupClassifiers.set(field.getCompoundCategorySystemName(), new Set());
                            }
                            // add classifier id to collected set
                            lookupClassifiers.get(field.getCompoundCategorySystemName()).add(entity[field.getSystemName()]);
                            break;
                        }
                        case idm_kb_service_client_js_1.MetaFieldType.MULTI_SELECT: {
                            // prepare classifier collected set
                            if (!lookupClassifiers.has(field.getCompoundCategorySystemName())) {
                                lookupClassifiers.set(field.getCompoundCategorySystemName(), new Set());
                            }
                            // add classifier id to collected set
                            for (var _b = 0, _c = entity[field.getSystemName()]; _b < _c.length; _b++) {
                                var id = _c[_b];
                                lookupClassifiers.get(field.getCompoundCategorySystemName()).add(id);
                            }
                            break;
                        }
                        case idm_kb_service_client_js_1.MetaFieldType.MAIN_ENTITY: {
                            // prepare main entity collected set
                            if (!lookupEntities.has(field.getCompoundCategorySystemName())) {
                                lookupEntities.set(field.getCompoundCategorySystemName(), new Set());
                            }
                            // add entity id to collected set
                            lookupEntities.get(field.getCompoundCategorySystemName()).add(entity[field.getSystemName()]);
                            break;
                        }
                        case idm_kb_service_client_js_1.MetaFieldType.SUB_ENTITY: {
                            var subEntityLookupFields = this.collectCompoundFields(entity[field.getSystemName()], entityMetaFields.subFields.get(field.getCompoundCategorySystemName()));
                            // collect sub entities classifiers
                            for (var _d = 0, _e = Array.from(subEntityLookupFields.lookupClassifiers.keys()); _d < _e.length; _d++) {
                                var classifierCategory = _e[_d];
                                for (var _f = 0, _g = Array.from(subEntityLookupFields.lookupClassifiers.get(classifierCategory)); _f < _g.length; _f++) {
                                    var classifierId = _g[_f];
                                    // prepare classifier collected set
                                    if (!lookupClassifiers.has(classifierCategory)) {
                                        lookupClassifiers.set(classifierCategory, new Set());
                                    }
                                    // add classifier id to collected set
                                    lookupClassifiers.get(classifierCategory).add(classifierId);
                                }
                            }
                            // collect sub entities main entities
                            for (var _h = 0, _j = Array.from(subEntityLookupFields.lookupEntities.keys()); _h < _j.length; _h++) {
                                var entityCategory = _j[_h];
                                for (var _k = 0, _l = Array.from(subEntityLookupFields.lookupEntities.get(entityCategory)); _k < _l.length; _k++) {
                                    var entityId = _l[_k];
                                    // prepare main entity collected set
                                    if (!lookupEntities.has(entityCategory)) {
                                        lookupEntities.set(entityCategory, new Set());
                                    }
                                    // add entity id to collected set
                                    lookupEntities.get(entityCategory).add(entityId);
                                }
                            }
                            break;
                        }
                    }
                }
            }
        }
        return new lookup_fields_1.LookupFields(entityMetaFields, lookupClassifiers, lookupEntities);
    };
    EntitySearchHelperNewService.prototype.collectFieldsToDeserialize = function (category, entityMetaFields) {
        var entityFields = entityMetaFields.fields;
        var fieldsToDeserialize = new Map();
        var asyncOperations$ = [];
        var _loop_3 = function (field) {
            var fieldType = field.getType();
            switch (fieldType) {
                case idm_kb_service_client_js_1.MetaFieldType.MAIN_ENTITY: {
                    // understand which field must be loaded and deserialized
                    // note, that if current category has several lookup to same entity, all main-entity-meta-fields for each field will be considered and loaded/deserialized
                    asyncOperations$.push(this_2._kbService.getMainEntityMetaFields(category, field.getSystemName()).pipe(operators_1.tap(function (mainEntityMetaFields) {
                        if (!fieldsToDeserialize.has(field.getCompoundCategorySystemName())) {
                            fieldsToDeserialize.set(field.getCompoundCategorySystemName(), new Set(mainEntityMetaFields.map(function (value) { return value.getSystemName(); })));
                        }
                        else {
                            mainEntityMetaFields.map(function (value) { return value.getSystemName(); }).forEach(function (value) {
                                fieldsToDeserialize.get(field.getCompoundCategorySystemName()).add(value);
                            });
                        }
                    })));
                    break;
                }
                case idm_kb_service_client_js_1.MetaFieldType.SUB_ENTITY: {
                    // recursive call for sub-entity
                    asyncOperations$.push(this_2.collectFieldsToDeserialize(field.getCompoundCategorySystemName(), entityMetaFields.subFields.get(field.getCompoundCategorySystemName())).pipe(operators_1.map(function (nestedEntityFieldsToDeserialize) {
                        // merge information about fields to deserialize
                        nestedEntityFieldsToDeserialize.forEach(function (fields, key) {
                            if (!fieldsToDeserialize.has(key)) {
                                fieldsToDeserialize.set(key, fields);
                            }
                            else {
                                fields.forEach(function (value) { return fieldsToDeserialize.get(key).add(value); });
                            }
                        });
                    })));
                    break;
                }
            }
        };
        var this_2 = this;
        for (var _i = 0, entityFields_2 = entityFields; _i < entityFields_2.length; _i++) {
            var field = entityFields_2[_i];
            _loop_3(field);
        }
        if (asyncOperations$.length) {
            return Observable_1.Observable.zip.apply(Observable_1.Observable, asyncOperations$).pipe(operators_1.map(function () {
                return fieldsToDeserialize;
            }));
        }
        return Observable_1.Observable.of(fieldsToDeserialize);
    };
    /**
     * Load all specified lookup fields values
     * @param category Category of entities
     * @param entityMetaFields Main or sub entity KB meta fields and child sub entities fields
     * @param lookupFields  Category names and ids to be loaded.
     * @param categoryPermissionTypes
     * @param classifierService
     * @return Specified category values by specified ids.
     * @private
     */
    EntitySearchHelperNewService.prototype.loadCompoundFields = function (category, entityMetaFields, lookupFields, categoryPermissionTypes, classifierService) {
        var _this = this;
        var loadClassifiers$ = this.loadClassifiers(lookupFields.lookupClassifiers);
        var loadMainEntities$ = this.collectFieldsToDeserialize(category, entityMetaFields).pipe(operators_1.switchMap(function (fieldsToDeserialize) {
            return _this.loadMainEntities(lookupFields.lookupEntities, fieldsToDeserialize, categoryPermissionTypes);
        }));
        return Observable_1.Observable.zip(loadClassifiers$, loadMainEntities$).pipe(operators_1.map(function (data) {
            var classifiers = data[0];
            var entities = data[1];
            // collect classifier values
            var lookupClassifiersValues = new Map();
            for (var _i = 0, _a = Array.from(classifiers.keys()); _i < _a.length; _i++) {
                var classifierCategory = _a[_i];
                var classifiersResponse = classifiers.get(classifierCategory);
                // make sure the classifier exists in map
                if (!lookupClassifiersValues.has(classifierCategory)) {
                    lookupClassifiersValues.set(classifierCategory, new Map());
                }
                // put classifiers into the result map
                for (var _b = 0, _c = classifiersResponse.getData(); _b < _c.length; _b++) {
                    var classifier = _c[_b];
                    lookupClassifiersValues.get(classifierCategory).set(classifier.getId(), classifier);
                }
            }
            // collect entity values
            var lookupEntitiesValues = new Map();
            for (var _d = 0, _e = Array.from(entities.keys()); _d < _e.length; _d++) {
                var entityCategory = _e[_d];
                var entityResponse = entities.get(entityCategory);
                // make sure the entity exists in map
                if (!lookupEntitiesValues.has(entityCategory)) {
                    lookupEntitiesValues.set(entityCategory, new Map());
                }
                // put entities into the result map
                for (var _f = 0, _g = entityResponse.getData(); _f < _g.length; _f++) {
                    var entity = _g[_f];
                    lookupEntitiesValues.get(entityCategory).set(entity.getInstanceId(), entity);
                }
            }
            var lookupFieldsValues = new lookup_fields_values_1.LookupFieldsValues();
            lookupFieldsValues.lookupFields = lookupFields;
            lookupFieldsValues.lookupClassifiersValues = lookupClassifiersValues;
            lookupFieldsValues.lookupEntitiesValues = lookupEntitiesValues;
            return lookupFieldsValues;
        }));
    };
    /**
     * Load specified classifiers
     * @param lookupClassifiers
     * @private
     */
    EntitySearchHelperNewService.prototype.loadClassifiers = function (lookupClassifiers) {
        var loadClassifiers$ = [];
        var _loop_4 = function (classifierCategory) {
            var classifierIds = Array.from(lookupClassifiers.get(classifierCategory));
            if (classifierIds.length > 0) {
                loadClassifiers$.push(this_3._classifierService.loadClassifiersByIds(classifierCategory, classifierIds)
                    .pipe(operators_1.map(function (value) { return new Map().set(classifierCategory, value); })));
            }
        };
        var this_3 = this;
        for (var _i = 0, _a = Array.from(lookupClassifiers.keys()); _i < _a.length; _i++) {
            var classifierCategory = _a[_i];
            _loop_4(classifierCategory);
        }
        if (loadClassifiers$.length > 0) {
            return Observable_1.Observable.zip.apply(Observable_1.Observable, loadClassifiers$).pipe(operators_1.map(function (classifiers) {
                var response = new Map();
                for (var _i = 0, classifiers_1 = classifiers; _i < classifiers_1.length; _i++) {
                    var classifier = classifiers_1[_i];
                    for (var _a = 0, _b = Array.from(classifier.keys()); _a < _b.length; _a++) {
                        var classifierCategory = _b[_a];
                        response.set(classifierCategory, classifier.get(classifierCategory));
                    }
                }
                return response;
            }));
        }
        return Observable_1.Observable.of(new Map());
    };
    /**
     * Load specified main entities
     * @param lookupEntities
     * @param fieldsToDeserialize  Optional parameters to specify which fields must be considered.
     * @param categoryPermissionTypes
     * @private
     */
    EntitySearchHelperNewService.prototype.loadMainEntities = function (lookupEntities, fieldsToDeserialize, categoryPermissionTypes) {
        var _this = this;
        var loadEntities$ = [];
        var _loop_5 = function (entityCategory) {
            var entityIds = Array.from(lookupEntities.get(entityCategory));
            if (entityIds.length > 0) {
                var loadEntity$ = this_4._kbService.getInstanceMetaField(entityCategory).pipe(operators_1.switchMap(function (instanceMetaField) {
                    // construct main entity instance id filter
                    var filterBuilder = new idm_de_core_frontend_1.FilterBuilder();
                    filterBuilder.in(instanceMetaField.getSystemName(), entityIds);
                    // specify which fields to load from server
                    var fieldsToLoad = new Map();
                    fieldsToLoad.set(entityCategory, Array.from(fieldsToDeserialize.get(entityCategory)));
                    // load lookup main entities
                    return _this._entitySearchService.loadPortfolioItemsByFields2(entityCategory, new idm_de_core_frontend_1.PagingOptions(0, 10000), undefined, filterBuilder.build().toJson(), undefined, categoryPermissionTypes, fieldsToLoad)
                        .pipe(operators_1.map(function (responseData) { return new Map().set(entityCategory, responseData); }));
                }));
                loadEntities$.push(loadEntity$);
            }
        };
        var this_4 = this;
        for (var _i = 0, _a = Array.from(lookupEntities.keys()); _i < _a.length; _i++) {
            var entityCategory = _a[_i];
            _loop_5(entityCategory);
        }
        if (loadEntities$.length > 0) {
            return Observable_1.Observable.zip.apply(Observable_1.Observable, loadEntities$).pipe(operators_1.map(function (entities) {
                var response = new Map();
                for (var _i = 0, entities_2 = entities; _i < entities_2.length; _i++) {
                    var entity = entities_2[_i];
                    for (var _a = 0, _b = Array.from(entity.keys()); _a < _b.length; _a++) {
                        var entityCategory = _b[_a];
                        response.set(entityCategory, entity.get(entityCategory));
                    }
                }
                return response;
            }));
        }
        return Observable_1.Observable.of(new Map());
    };
    EntitySearchHelperNewService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_kb_service_client_js_1.KbService,
            idm_message_language_service_client_js_1.LanguageService,
            idm_classifier_service_client_js_1.ClassifierService,
            entity_service_1.EntitySearchService])
    ], EntitySearchHelperNewService);
    return EntitySearchHelperNewService;
}());
exports.EntitySearchHelperNewService = EntitySearchHelperNewService;
//# sourceMappingURL=entity-helper-new.service.js.map